import { footerGroups } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-200/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <a href="#top" className="flex cursor-pointer items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-compass-3-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料导航</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              一份持续维护的吃瓜站点目录。以分类为骨架，以合集为入口，把
              <strong className="mx-1 font-semibold text-foreground-900">黑料导航资源</strong>
              整理得更好找、更好读。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['分类更新', '快讯归档', '合集推荐'].map((chip) => (
                <span
                  key={chip}
                  className="rounded-full border border-background-300 bg-background-50 px-3 py-1 font-label text-xs text-foreground-600"
                >
                  {chip}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="cursor-pointer hover:text-primary-700">
                  {group.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer font-label text-xs text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-foreground-500">
            本站仅做站点分类与目录整理，所有内容指向第三方站点。
          </p>
          <p className="font-label text-xs text-foreground-500">
            黑料导航 · 分类大全与资源合集持续更新
          </p>
        </div>
      </div>
    </footer>
  );
}